import { ConfirmDialog } from '../../../../../shared/ui/confirm-dialog/ConfirmDialog';

export function DiscardChangesDialog({
  open,
  onClose,
  onDiscard,
  onSave,
  saveLabel = 'Save Changes',
}) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onDiscard}
      onSave={onSave}
      title="Discard Changes"
      body="You have unsaved changes that will be lost if you leave without saving."
      confirmLabel="Discard Changes"
      cancelLabel="Keep Editing"
      saveLabel={saveLabel}
      confirmVariant="danger"
    />
  );
}
